import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=c83d2132&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c83d2132')) {
      api.createRecord('c83d2132', component.options)
    } else {
      api.reload('c83d2132', component.options)
    }
    module.hot.accept("./Gallery.vue?vue&type=template&id=c83d2132&", function () {
      api.rerender('c83d2132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/gallery/Gallery.vue"
export default component.exports